const requestAnimationFrame = window.requestAnimationFrame || window.mozRequestAnimationFrame ||
  window.webkitRequestAnimationFrame || window.msRequestAnimationFrame;

const cancelAnimationFrame = window.cancelAnimationFrame || window.mozCancelAnimationFrame;

export const delay = (callback, delay) => {
  const start = performance.now();
  let request = null;

  const ticker = timestamp => {
    const progress = timestamp - start;
    if (progress < delay) {
      request = requestAnimationFrame(ticker);
    } else if (progress >= delay) {
      cancelAnimationFrame(request);
      callback();
    }
  };
  requestAnimationFrame(ticker);
  return {
    cancel: () => {
      cancelAnimationFrame(request);
    },
  };
};

